<template>
  <v-footer padless>
    <v-row justify="center" no-gutters>
      <v-col class="py-4 text-center" cols="12">
        <!-- Тема и язык -->
        <div class="d-flex justify-center align-center flex-wrap mb-2">
          <v-icon @click="changeTheme()" class="mx-2 footer-icon">
            mdi-theme-light-dark
          </v-icon>
          <select
            v-model="select_locale"
            item-text="text"
            item-value="value"
            :class="['footer-select', $vuetify.theme.dark ? 'white--text' : 'black--text']"
          >
            <option v-for="(lang, i) in locales" :key="`Lang${i}`" :value="lang.value" >
              {{ lang.text }}
            </option>
          </select>
        </div>

        <!-- Ссылки -->
        <div class="d-flex justify-center align-center flex-wrap mb-2 footer-links">
          <a 
            :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/agreement`" 
            target="_blank" 
            class="footer-link mx-2 my-1"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >{{ $t('custom.user_agreement') }}</a>
          <span class="d-none d-sm-inline mx-1">|</span>
          <a 
            :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/privacy`" 
            target="_blank" 
            class="footer-link mx-2 my-1"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >{{ $t('custom.privacy_policy') }}</a>
          <span class="d-none d-sm-inline mx-1">|</span>
          <a 
            :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/agreement#refund`" 
            target="_blank" 
            class="footer-link mx-2 my-1"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >{{ $t('custom.refund_policy') }}</a>
          <span class="d-none d-sm-inline mx-1">|</span>
          <a 
            :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/tariffs`" 
            target="_blank" 
            class="footer-link mx-2 my-1"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >{{ $t('custom.pricing') }}</a>
        </div>

        <!-- Копирайт и версия -->
        <div class="d-flex justify-center align-center flex-wrap footer-info">
          <span class="mx-1">{{ new Date().getFullYear() }} — <strong>RentProg</strong></span>
          <span class="d-none d-sm-inline mx-1">|</span>
          <span class="mx-1">{{ checkAppVersion() }}</span>
          <span v-if="$store.getters.getRegion" class="mx-1 text-uppercase font-weight-bold" style="opacity: 0.1; font-size: 12px;">{{ $store.getters.getRegion }}</span>
        </div>
      </v-col>
    </v-row>
    <vue-cookie-accept-decline
      :debug="false"
      :disableDecline="false"
      :showPostponeButton="false"
      @clicked-decline="cookieClickedDecline"
      elementId="cookiePanel"
      position="bottom-left"
      ref="cookiePanel"
      transitionName="slideFromBottom"
      type="floating"
    >
      <!-- Optional -->
      <template #postponeContent>&times;</template>

      <!-- Optional -->
      <template #message>
        <p :class="$vuetify.theme.dark ? 'black--text' : ''">{{ $t('gdrp.text') }}
          <a :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/privacy`" target="_blank">{{ $t('gdrp.more') }}...</a>
        </p>
      </template>

      <!-- Optional -->
      <template #declineContent>{{ $t('gdrp.decline') }}</template>

      <!-- Optional -->
      <template #acceptContent>{{ $t('gdrp.accept') }}</template>
    </vue-cookie-accept-decline>
  </v-footer>
</template>
<script>
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import appVersion from '@/version.js';
export default {
  data() {
    return {
      locales: [
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      select_locale: this.$i18n.locale
    }
  },
  watch: {
    select_locale() {
      this.$i18n.locale = this.select_locale
      this.$root.$i18n.locale = this.select_locale
      localStorage.setItem("lang", this.select_locale)
    }
  },
  methods: {
    cookieClickedDecline() {
      this.$refs.cookiePanel.removeCookie()
    },
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    },
    checkAppVersion() {
      // Получаем информацию о текущем приложении
      if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
        const appInfo = App.getInfo();
        return appInfo.version || appVersion.version;
      } else {
        return appVersion.version || '';
      }
    },
  }
};
</script>
<style scoped>
.footer-icon {
  cursor: pointer;
  font-size: 24px !important;
}

.footer-select {
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background-color: transparent;
  font-size: 14px;
  min-height: 32px;
}

.v-theme--dark .footer-select {
  border-color: rgba(255, 255, 255, 0.12);
}

.footer-links {
  font-size: 14px;
  line-height: 1.5;
}

.footer-link {
  text-decoration: none;
  padding: 4px 0;
  display: inline-block;
  min-height: 32px;
  line-height: 24px;
}

.footer-link:hover {
  text-decoration: underline;
}

.footer-info {
  font-size: 13px;
}

/* Мобильные устройства */
@media (max-width: 600px) {
  .footer-links {
    font-size: 13px;
  }
  
  .footer-link {
    margin: 4px 8px !important;
  }
  
  .footer-info {
    font-size: 12px;
  }
}
</style>
